export function announcementLink (value) {
  const url = String(value || '').trim()
  if (!url || /[\\\s\u0000-\u001f\u007f]/.test(url)) return ''
  if (url.charAt(0) === '/' && url.charAt(1) !== '/') return url
  if (!/^https?:\/\//i.test(url)) return ''
  try {
    const parsed = new URL(url)
    return parsed.hostname && !parsed.username && !parsed.password ? url : ''
  } catch (e) { return '' }
}

export function announcementKey (item) {
  return JSON.stringify([item.id, item.updatedAt, item.title, item.content, item.buttonText, item.targetUrl, item.displayScope])
}



// WEBPACK FOOTER //
// ./src/utils/announcement.js